import type { CSSProperties } from "react";

export type PlatformLogoVariant = "selector" | "dropdown";

type PlatformLogoSize = {
  width: number | string;
  height: number | string;
};

type PlatformLogoVariantConfig = {
  default: PlatformLogoSize;
  byPlatformId: Record<string, Partial<PlatformLogoSize>>;
};

// Per-platform logo sizes — tweak width/height here for each context.
export const PLATFORM_LOGO_SIZES: Record<PlatformLogoVariant, PlatformLogoVariantConfig> = {
  selector: {
    default: { width: 100, height: 36 },
    byPlatformId: {
      MFL: { width: 100, height: 36 },
      Sleeper: { width: 100, height: 36 },
      Flea_flicker: { width: 100, height: 36 },
      Yahoo: { width: 100, height: 36 },
      ESPN: { width: 100, height: 36 },
      Fantrax: { width: 100, height: 36 },
      FFPC: { width: 100, height: 34 },
    },
  },
  dropdown: {
    default: { width: 130, height: 45 },
    byPlatformId: {
      MFL: { width: 140, height: 48 },
      Sleeper: { width: 110, height: 40 },
      Flea_flicker: { width: 120, height: 45 },
      Yahoo: { width: 140, height: 45 },
      ESPN: { width: 100, height: 40 },
      Fantrax: { width: 120, height: 45 },
      FFPC: { width: 120, height: 45 },
    },
  },
};

// CSS filters for dark-brand SVGs on #222 background (easy to remove/tweak per platform).
export const PLATFORM_LOGO_FILTERS: Record<string, string> = {
  Yahoo: "brightness(2.5) contrast(1.05)",
  MFL: "brightness(1.85) contrast(1.08)",
};

export const getPlatformLogoStyle = (
  platformId: string,
  variant: PlatformLogoVariant
): CSSProperties => {
  const config = PLATFORM_LOGO_SIZES[variant];
  const overrides = config.byPlatformId[platformId] ?? {};
  const size = { ...config.default, ...overrides };

  return {
    width: size.width,
    height: size.height,
    objectFit: "contain",
    // ...(PLATFORM_LOGO_FILTERS[platformId] ? { filter: PLATFORM_LOGO_FILTERS[platformId] } : {}),
  };
};
